export default __webpack_public_path__ + "static/media/villa.62f27354.png";